import { render, staticRenderFns } from "./VerFichero.vue?vue&type=template&id=9591405c&"
import script from "./VerFichero.vue?vue&type=script&lang=ts&"
export * from "./VerFichero.vue?vue&type=script&lang=ts&"
import style0 from "./VerFichero.vue?vue&type=style&index=0&id=9591405c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports